import { ref, onBeforeUnmount } from 'vue'

const MOBILE_BREAKPOINT_PX = 768

// Below this width DevExtreme's column-hiding ("...") replaces fixed-width columns that would
// otherwise be unreadable; desktop always shows every column.
export function useNarrowViewport() {
  const isNarrowViewport = ref(window.innerWidth < MOBILE_BREAKPOINT_PX)
  const update = () => { isNarrowViewport.value = window.innerWidth < MOBILE_BREAKPOINT_PX }
  window.addEventListener('resize', update)
  onBeforeUnmount(() => window.removeEventListener('resize', update))
  return isNarrowViewport
}
